import { render, staticRenderFns } from "./TabManutencaoTabela.vue?vue&type=template&id=7380ef4f&"
import script from "./TabManutencaoTabela.vue?vue&type=script&lang=ts&"
export * from "./TabManutencaoTabela.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports